<template>
  <div class="refer-earn-component">
    <div class="section-2">
      <div class="refer-img">
        <img
          src="../../assets/images/ExpertLandingPage/footer/advisor/refer and earn.png"
          alt=""
        />
      </div>
      <el-row>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>

        <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
          <div class="special-sec">
            <h1 style="font-size: 2rem; color: #322e79">
              Refer to your friends colleague and earn
            </h1>
          </div>
          <div class="">
            <h1 style="color: #322e79">How you can refer and earn</h1>
            <h1>Terms & Conditions:</h1>

            <ul>
              <li>
                This Scheme is applicable for all existing StockAnts Users only.
              </li>

              <li>
                The Referrer will get rewarded Rs. 20/- on each eligible account
                referred. The minimum payout under this scheme has to be Rs.
                200, for you to be able to withdraw your referral earnings.
                Payment of the rewards will be initiated in the first week of
                the preceding month.
              </li>

              <li>Unique Referral code will be assigned to each user.</li>

              <li>
                The referred should be a new registered user of StockAnts. New
                user consideration would be done basis unique Mobile Number and
                Email ID in StockAnts system of the referred user.
              </li>

              <li>
                If the details provided by referred are incomplete/ incorrect/
                invalid, the Referrer who has provided a reference shall not be
                entitled to any reward under the Referral Program.
              </li>

              <li>
                The mobile number used by the referred to sign up shouldn’t have
                been used earlier for opening an account with StockAnts.
              </li>

              <li>
                StockAnts reserves the right, in its absolute discretion, to
                change, alter or discontinue the offer and alter the terms and
                conditions from time to time.
              </li>

              <li>
                The maximum referral bonus that can be earned by a referrer is
                capped and may differ for each referral offer.
              </li>

              <li>
                StockAnts reserves all rights to change the amounts conferred
                under Refer and Earn program at any point in time.
              </li>

              <li>
                StockAnts may suspend or terminate the Refer and Earn program or
                any user’s ability to participate in the program at any time for
                any reason at their discretion. Points earned as a result of
                fraudulent activities will be revoked and deemed invalid.
              </li>

              <li>
                StockAnts reserves the right to amend these terms and conditions
                at any time without any prior notice.
              </li>

              <li>
                Any Grievances related to above scheme/offer/campaign would not
                be entertained on Exchange Platform and will not be covered
                under investor protection or grievance redressal measures of the
                Exchange.
              </li>
            </ul>
          </div>

          <div class="special-sec">
            <h1>Note</h1>
            <p>
              <span style="font-weight: 700; ">Referrer - </span> A Candidate and voluntarily participates in the Scheme by referring eligible friends to become Referees.
            </p>
            <p>
              <span style="font-weight: 700; ">Referred - </span> A Candidate to whom the Referrer has Invited to Join StockAnts.
            </p>
          </div>
        </el-col>

        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "ReferAndEarnComponent",

  components: {},

  mixins: [],

  data() {
    return {};
  },

  methods: {},

  computed: {},
};
</script>
<style lang="scss" scoped>
.refer-earn {
  .section-2 {
    position: relative;
    .refer-img {
      position: absolute;
      right: 12%;
      width: 25%;
      top: 30px;
      img {
        width: 100%;
      }
    }
    .special-sec {
      margin: 0px 0;
    }
    h1 {
      font-size: 1.6rem;
      font-weight: 600;
    }
    p {
      font-size: 0.9rem;
      color: #6d6a6a;
    }
    ul {
      list-style: none;
      li {
        font-size: 0.9rem;
        margin: 10px 0;
        color: #6d6a6a;
      }
      li::before {
        content: "\2022";
        color: #322e79;
        font-weight: bold;
        width: 1em;
        margin-left: -1em;
        font-size: 45px;
        position: relative;
        margin-right: 25px;
        top: 7px;
      }
    }
  }

  @media screen and (max-width: 876px) {
    .section-2 {
      padding: 0 70px;
      .refer-img {
        position: unset;
        width: 100%;
        text-align: center;
        img {
          width: 50%;
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    .section-2 {
      padding: 0 35px;
    }
  }
  @media screen and (max-width: 450px) {
    .section-2 {
      padding: 0 20px;
    }
  }
}
</style>


